<script>
import { user } from "../store";


</script>


<div class="left">
    <a href="#" class="logo"></a>
    {#if $user.loggedIn}
    <div class="nav">
        <a href="#/dashboard">Customers</a>
        
    </div>
    {/if}
</div>
{#if $user.loggedIn}
<div class="right">
  <!--  <div class="searchbar">
        <form>
            <input type="text" class="searchbox" />
            <input type="submit" class="searchicon" value="" />
        </form>
    </div>
    -->
    <div class="highlight_links">
        <a href="#/compliance/checklist" class="bold">My Audit</a> 
        <a href="#/compliance/checklist/list" class="">Audit List</a> 
        <a href="#/compliance/assets" class="">Assets</a> 
        <a href="#/customer">+ Add New Customer</a>
    </div>
</div>
{/if}